var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 2.85938C0.441406 2.85938 0.25 2.66797 0.25 2.42188V1.32812C0.25 1.10938 0.441406 0.890625 0.6875 0.890625H12.0625C12.2812 0.890625 12.5 1.10938 12.5 1.32812V2.42188C12.5 2.66797 12.2812 2.85938 12.0625 2.85938H0.6875ZM0.6875 7.23438C0.441406 7.23438 0.25 7.04297 0.25 6.79688V5.70312C0.25 5.48438 0.441406 5.26562 0.6875 5.26562H12.0625C12.2812 5.26562 12.5 5.48438 12.5 5.70312V6.79688C12.5 7.04297 12.2812 7.23438 12.0625 7.23438H0.6875ZM0.6875 11.6094C0.441406 11.6094 0.25 11.418 0.25 11.1719V10.0781C0.25 9.85938 0.441406 9.64062 0.6875 9.64062H12.0625C12.2812 9.64062 12.5 9.85938 12.5 10.0781V11.1719C12.5 11.418 12.2812 11.6094 12.0625 11.6094H0.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.a837639edaa06a1d3b9342684a4a89a5.svg";
export { ForwardRef as ReactComponent };